import { ConfigMenuCategory, ConfigMenuItem } from './navTypes';

export type UrlLocation = {
  // The category or module pointed by the URL
  category?: ConfigMenuCategory;
  // The subcategory / page pointed by the URL
  item?: ConfigMenuItem;
};

export const parseUrlLocation = (
  pathname: string,
  menuCategories: ConfigMenuCategory[],
): UrlLocation => {
  // TODO FDPE-3718: re-write in recursive way to be able support sub-menus
  const pathSplits = pathname.split('/'); // it will return smth like ["", "categoryId", "subcategoryId"]
  const categoryId = pathSplits[1];
  const subcategoryId = pathSplits[2];

  // we find root category
  let urlCategory = menuCategories?.find((item) => item.id === categoryId);
  if (!urlCategory) {
    // fix for cases when module name is different from menu category id (e.g. "dashboard" module in the "analytics" section)
    for (const category of menuCategories) {
      for (const item of category.items) {
        if (item.id === categoryId) {
          urlCategory = category;
          break;
        }

        const [, mainPart] = item.href.split('/');
        if (mainPart === categoryId) {
          urlCategory = category;
          break;
        }
      }
    }
  }
  // inside root category we find subcategory
  const urlItem = urlCategory?.items.find((item) => item.id === subcategoryId);

  return {
    category: urlCategory,
    item: urlItem,
  };
};
